export type MessageId = string;

export type ConnectorOptions = {
    targetOrigin: string;
    allowedOrigins: string[];
};

export namespace MessageId{
    export function generate(): MessageId {
        if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
        // Use Web Crypto API if available
        return crypto.randomUUID();
        }
        // Fallback: Generate random hex string (not a true UUID)
        return (
        Date.now().toString(16) +
        Math.random().toString(16).substring(2, 10)
        );
    }
}

export abstract class Message{
    static type: string;
    static version: number;
}

export class InitMessage extends Message{
    static type = "InitMessage" as const;
    static version = 1 as const;
    supportedProtocolVersions: number[] = [];
    requestingMessageTypes: {[type: string]: number[]} = {
        [InitMessage.type]: [InitMessage.version], 
        [InitResponseMessage.type]: [InitResponseMessage.version],
        [InitRejectedMessage.type]: [InitRejectedMessage.version]
    };
}

export class InitResponseMessage extends Message{
    static type = "InitResponseMessage" as const;
    static version = 1 as const;
    chosenProtocolVersion: number;
    offeredMessageTypes: {[type: string]: number[]} = {};
    constructor(chosenProtocolVersion: number){
        super();
        this.chosenProtocolVersion = chosenProtocolVersion; 
    }
}

export class InitRejectedMessage extends Message{
    static type = "InitRejectedMessage" as const;
    static version = 1 as const;
    reason: string;
    constructor(reason: string){
        super();
        this.reason = reason;
    }
}

export interface Envelope<P extends Message>{
    protocolVersion: number;
    type: string;
    id?: MessageId; 
    source?: string;
    target?: string;
    replyTo?: MessageId;
    contentEncoding?: string;
    contentType?: string;
    payload: P;
}

export interface Connector{
    init(settings: any): void;
    send(message: Message): void;
    onMessage(type: string, callback: (msg: Message, envelope?: Envelope<Message> | undefined)=>void): void;
    onReceived(callback: (envelope: Envelope<Message>)=>void): void;
    close(): void;
}